/**
 * Creation tool's gif/video creation and uploading status.
 */
enum CreationToolStatus {
    Idle = 'CT_STATUS_IDLE',
    Generating = 'CT_STATUS_GENERATING',
    Uploading = 'CT_STATUS_UPLOADING',
    Downloading = 'CT_STATUS_DOWNLOADING',
    Complete = 'CT_STATUS_COMPLETE',
}

namespace CreationToolStatus {
    /**
     * Returns the status' description text for display.
     */
    export function description(status: CreationToolStatus): string {
        switch (status) {
            case CreationToolStatus.Idle:
                return ''
            case CreationToolStatus.Generating:
                return 'Generating'
            case CreationToolStatus.Uploading:
                return 'Uploading'
            case CreationToolStatus.Downloading:
                return 'Downloading'
            case CreationToolStatus.Complete:
                return 'Completing'
        }
    }
}

export default CreationToolStatus
